import getStore from '../store/store';
import {
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    EventCaptureOptions,
} from 'owa-outlook-service-options';
import { getFallbackValueIfNull } from 'owa-options-core';
import { toJS } from 'mobx';

/**
 * Called when save option is selected, saves the guided capture options in store
 */
export default async function saveGuidedCaptureOptions(): Promise<void> {
    let optionsState = getStore();
    let userOptions: EventCaptureOptions = toJS(
        getOptionsForFeature<EventCaptureOptions>(OwsOptionsFeatureType.EventCapture)
    );

    userOptions.autoCollectionEnabled = getFallbackValueIfNull(
        optionsState.autoCollectionEnabled,
        userOptions.autoCollectionEnabled
    );

    return lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.EventCapture,
        userOptions
    );
}
